import React from 'react';
import styled, { css } from 'styled-components';

import {
  ELEMENT_ACTION,
  ICON_TYPES,
  POSITIONS,
} from '../../../shared/constants';

import { DEQ_TYPES } from '../../../utils/deq';

import mq from '../../../styles/breakpoints';
import { Body } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

import { ChevronLeft } from '../icons/ChevronLeft';
import CloseIcon from '../icons/CloseIcon';

interface Props {
  text: string;
  href?: string;
  closeOnClick?: () => void;
  parentCompType: string;
  align: string;
  iconType?: string;
  color: string;
}

const CloseTextLink = ({
  text,
  href,
  closeOnClick,
  parentCompType,
  align = 'left',
  iconType = ICON_TYPES.close,
  color,
}: Props) => {
  return (
    <LinkWrapper
      color={color}
      href={href ?? undefined}
      onClick={closeOnClick ?? undefined}
      data-testid="form-cancel-link"
      data-element-label={text?.toLowerCase()}
      data-component-type={parentCompType}
      data-element-type={DEQ_TYPES.textLink}
      data-element-target={href}
      align={align}
      icon={iconType}
    >
      {iconType === ICON_TYPES.close && <CloseIcon width="14" height="14" />}
      {iconType === ICON_TYPES.chevronLeft && <ChevronLeft />}
      <LinkText align={align}>{text}</LinkText>
    </LinkWrapper>
  );
};

export default CloseTextLink;

const LinkWrapper = styled.a<{ color: string; align: string; icon: string }>`
  align-items: center;
  color: ${({ color }) => color};
  cursor: pointer;
  display: flex;
  text-decoration: none;

  ${({ icon }) =>
    icon === ICON_TYPES.chevronLeft &&
    css`
      margin-left: -${Spacings.XS};
    `}

  ${({ align }) =>
    align === POSITIONS.right
      ? css`
          flex-direction: row-reverse;
          justify-content: flex-end;
        `
      : css`
          flex-direction: initial;
          justify-content: flex-start;
        `}

  > svg {
    color: inherit;
    top: 4px;
  }
`;

const LinkText = styled(Body)<{ align: string }>`
  color: inherit;
  margin: ${({ align }) =>
    align === POSITIONS.right ? '0 10px 0 0' : '0 0 0 10px'};

  ${mq.from.breakpoint.XL`
    font-size: ${({ align }: { align: string }) =>
      align === POSITIONS.right ? '18px' : '16px'};
  `}
`;
